import { Button, ButtonProps } from './ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useState } from 'react';

type LogoutButtonProps = Omit<
  ButtonProps,
  'onClick' | 'children' | 'disabled'
> & {
  goTo?: string;
};

export const LogoutButton = ({ goTo, ...props }: LogoutButtonProps) => {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const doLogout = async () => {
    setLoading(true);
    await logout();
    setLoading(false);
    // go to /
    window.location.href = goTo || '/';
  };

  return (
    <Button onClick={doLogout} disabled={loading} {...props}>
      Logout
    </Button>
  );
};
